module.exports = __webpack_public_path__ + "static/19-fcfaafa59ee6cc15e33a1f4a8babfe1e.jpg";